<template>
  <Tile>
    <Loader :loading="loading" :error="error">
      <TileContent
        :title="title"
        :tooltip="tooltip"
        @iconClick="emitIconClick"
      >
        <template v-slot:table>
          <Table
            :hide-default-footer="true"
            :outlined="true"
            :data="data"
            :loading="loading"
            :customColumns="customColumns"
            dense
          />
        </template>
      </TileContent>
    </Loader>
  </Tile>
</template>

<script>
import { mapState } from 'vuex';
import Tile from './Tile.vue';
import TileContent from './TileContent.vue';
import Table from './Table.vue';
import Loader from './Charting/Shared/Loader.vue';
import { getReportFieldFromValue } from '../../../services/dashboard/reportFieldService';

export default {
  props: {
    title: String,
    tooltip: String,
    data: Array,
    error: Boolean,
    loading: Boolean,
    dimensions: Array,
    metrics: Array,
  },
  components: {
    Tile,
    TileContent,
    Table,
    Loader,
  },
  computed: {
    ...mapState({
      allReportFields: state => state.dashboard.availableReportFields.allReportFields,
      allSegmentsDimension: state => state.dashboard.availableReportFields.allSegmentsDimension,
    }),
    dimensionReportField() {
      const dimension = this.dimensions[0];

      // Demographics Table needs a custom dimension obj for its first column
      if (dimension === this.allSegmentsDimension.value) {
        return ({
          ...this.allSegmentsDimension,
          name: this.allSegmentsDimension.key,
          snake: 'full_segment_name',
        });
      }

      return getReportFieldFromValue(this.allReportFields, dimension);
    },
    formattedDimensionColumn() {
      const formattedColumn = {
        value: this.dimensionReportField.snake,
        // column name is singular version of title
        name: this.title.slice(0, -1),
        align: 'left',
      };

      // Custom Demographics column name
      if (this.dimensionReportField.value === this.allSegmentsDimension.value) {
        formattedColumn.name = 'Segment Name';
      }

      return formattedColumn;
    },
    metricsReportFields() {
      return this.metrics.map(m => getReportFieldFromValue(this.allReportFields, m));
    },
    customColumns() {
      const metricColumns = this.metricsReportFields.map((m, i) => {

        const lastColumn = i === this.metricsReportFields.length - 1;

        return {
          value: m.snake,
          name: m.key,
          align: lastColumn ? 'right' : 'left',
        };
      });

      return [this.formattedDimensionColumn].concat(metricColumns);
    },
  },
  methods: {
    emitIconClick() {
      this.$emit('iconClick', {
        title: this.title,
        tableData: this.tableData,
      });
    },
  },
};
</script>

